export enum Priority {
  None = 0,
  Attention = 1,
  Important = 2,
}
